export const INIT_EXPRESSION = 'expression/INIT_EXPRESSION';
export const ADD_CONDITION = 'expression/ADD_CONDITION';
export const SET_CONDITIONS = 'expression/SET_CONDITIONS';
export const UPDATE_CONDITION = 'expression/UPDATE_CONDITION';
export const REMOVE_CONDITION = 'expression/REMOVE_CONDITION';
